import { FarmConverterTransform, FarmConverterTransformConfig, MapControlLegendType,} from 'src/app/domainObjects/transformers/farmConverterTransform';
import { DataFarmType } from 'src/app/domainObjects/dataFarmType';
import { FarmConverterTransformPreviewDataResponse } from 'src/app/messaging/farmConverterTransformPreviewDataResponse';
import { PreviewDataImportRequest } from 'src/app/messaging/previewImportDataRequest';
import { ConfigService } from 'src/app/services/config/config.service';
import { DataFarmViewModel } from 'src/app/viewModels/dataFarmViewModel';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { TransformerViewModel } from '../../../transformer-list/transformer-list.component';
import { TransformDetailViewModelBase } from '../../../dataTransformConfig/transformers/base/base-transformer-ui/transformDetailViewModelBase';
import { DataDictionaryService } from '../../../../services/dataDictionary/data-dictionary.service';
import { ValidationInfo, RequiredFieldValidation } from 'src/app/objectModel/validationInfo';
import { FarmConverterRuleViewModel } from './farmConverterRuleViewModel';
import { SortInfo } from 'src/app/domainObjects/sortInfo';
import { IncludeInfo } from 'src/app/domainObjects/includeInfo';
import { TransformerParametersViewModel } from '../transformer-parameters/transformerParametersViewModel';
import { OptionItem } from 'src/app/model/optionItem';
import { TransformType } from 'src/app/domainObjects/transformType';

export class MapControlLegendTypeUtil {
  static toString(condType: MapControlLegendType): string {
      switch (condType) {
        case MapControlLegendType.fcoptionone: return '../assets/images/fcoptionone.png';
        case MapControlLegendType.fcoptiontwo: return '../assets/images/fcoptiontwo.png';
        case MapControlLegendType.fcoptionthree: return '../assets/images/fcoptionthree.png';
        case MapControlLegendType.fcoptionfour: return '../assets/images/fcoptionfour.png';
        case MapControlLegendType.fcoptionfive: return '../assets/images/fcoptionfive.png';
      }
  }
}
export class FarmConverterTransformDetailViewModel extends TransformDetailViewModelBase<FarmConverterTransform> {
  farmType: DataFarmType;
  runAll: boolean;
  mapTable: Array<FarmConverterRuleViewModel> = [];
  sortInfoOut?: SortInfo[];
  // Status
  groupHitCount?: number;
  hitCount?: number;
  missCount?: number;
  hitRatio?: number;
  hitRatioDisplay?: string;

  inputRows?: number;
  outputRows?: number;
  aggRatio?: number;
  aggRatioDisplay?: string;
  
  resetRows: boolean;
  //Advanced Settings
  timestampField: string;
  groupBy: string;
  groupByL2: string;
  defSourceField: string;
  entityList: string;
  userField: string;
  bufferRows: number;
  threads: number;
  listSeparator: string;
  defTimeout: number;
  sequenceL2: boolean;
  delMisses: boolean;
  orderField : string;
  isOpenField: string;
  isCloseField: string;
  entityStart: string;
  entityEnd: string;
  subRows: string;
  addFields: string[];
  // Preview options
  rows: number;
  sampleStart: number;
  sampleEnd: number;

  entryListColumns: Array<string>=[];
  sortInfoOutColumns: OptionItem[]=[];

  request: PreviewDataImportRequest;
  response: FarmConverterTransformPreviewDataResponse;

    constructor(
      dataDictService: DataDictionaryService,
      private configService: ConfigService,
      configViewModel: DataTransformConfigViewModel,
      transformViewModel: TransformerViewModel) {
        super(dataDictService, configViewModel, transformViewModel);

        const transformConfig = this.transform.transformConfig;
        this.parameters=new TransformerParametersViewModel();
        if (transformConfig) {
          //console.log('Existing transformConfig used.');
          //console.log(transformConfig);

          //this.lookupFarmType = DataFarmType[transformConfig.lookupFarmType];
          this.farmType=transformConfig.farmType;
          this.sortInfo = transformConfig.sortInfo;
          this.sortInfoOut = transformConfig.sortInfoOut;
          this.sampleEnd = transformConfig.sampleEnd + 1;
          this.sampleStart = transformConfig.sampleStart + 1;
          this.runAll = transformConfig.runAll;
          this.timestampField = transformConfig.timestampField;
          this.groupBy = transformConfig.groupBy;
          this.groupByL2 = transformConfig.groupByL2;
          this.defSourceField = transformConfig.defSourceField;
          this.entityList = transformConfig.entityList;
          this.userField = transformConfig.userField;
          this.sequenceL2= transformConfig.sequenceL2,
          this.bufferRows= transformConfig.bufferRows,
          this.threads= transformConfig.threads,
          this.listSeparator = transformConfig.listSeparator;
          this.defTimeout= transformConfig.defTimeout,
          this.orderField = transformConfig.orderField;
          this.isOpenField = transformConfig.isOpenField;
          this.isCloseField = transformConfig.isCloseField;
          this.entityStart = transformConfig.entityStart;
          this.entityEnd = transformConfig.entityEnd;
          this.subRows = transformConfig.subRows;
          this.addFields = transformConfig.addFields;

          this.parameters.sampleStart = transformConfig.sampleStart+ 1;
          this.parameters.sampleEnd = transformConfig.sampleEnd+ 1;
          this.parameters.runAll= transformConfig.runAll;
          this.resetRows = transformConfig.resetRows;
          
          if (transformConfig.mapTable) {
            this.mapTable = transformConfig.mapTable.map(r => new FarmConverterRuleViewModel(r));
          }

        }
    }
public ConvertEnumToString(requst:number): string{
  var ret:string="";
  if(requst==DataFarmType.subTask){
    ret = "Subtask";
  }
  else if(requst==DataFarmType.task){
    ret = "Task";
  }
  else if(requst==DataFarmType.activity){
    ret = "Activity";
  }
  else if(requst==DataFarmType.cases){
    ret = "Case";
  }
  else if(requst== DataFarmType.users){
    ret ="User";
  }
  else if(requst==DataFarmType.behaviors){
    ret = "Behavior";
  }
  else if(requst==DataFarmType.master){
    ret = "Master";
  }
  return ret;
}
ConvertStringToEnum(requst:string): number{
  var ret:number=-1;
  if(requst=="Subtask"){
    ret = DataFarmType.subTask;
  }
  else if(requst=="Task"){
    ret = DataFarmType.task;
  }
  else if(requst=="Activity"){
    ret = DataFarmType.activity;
  }
  else if(requst=="Case"){
    ret = DataFarmType.cases;
  }
  else if(requst=="User"){
    ret = DataFarmType.users;
  }
  else if(requst=="Behavior"){
    ret = DataFarmType.behaviors;
  }
  else if(requst=="Master"){
     ret = DataFarmType.master;
  }
  return ret;
}
    override configureValidationInfo(): ValidationInfo[] {
      const infos = [];

      infos.push( new RequiredFieldValidation('timestampFieldaField', 'Advanced Settings: Source Time Stamp Field'));
      infos.push( new RequiredFieldValidation('groupByField', 'Advanced Settings: Group Subtasks By'));
      infos.push( new RequiredFieldValidation('groupByL2Field', 'Advanced Settings: Group Tasks By'));
      infos.push( new RequiredFieldValidation('defSourceFieldaField', 'Advanced Settings: List Source'));
      infos.push( new RequiredFieldValidation('entityListField', 'Advanced Settings:List Target'));
      infos.push( new RequiredFieldValidation('userFieldField', 'Advanced Settings:User Field'));
      return infos;
    }

    // reindexRules(): void {
    //   for (let i = 0; i < this.mapTable.length; i++) {
    //     this.mapTable[i].index = i + 1;
    //   }
    //   this.mapTable.sort((a, b) => a.index - b.index);
    // }

    public override toTransformConfig(): FarmConverterTransformConfig {
      const config = new FarmConverterTransformConfig();
      config.farmType=this.farmType;
      config.transformType = TransformType.farmConverter;
      if(this.sortInfo){
        if(this.sortInfo.length==0){
          config.sortInfo =undefined;
        }else{
          config.sortInfo=this.sortInfo;
        }
      }
      if(this.sortInfoOut){
        if(this.sortInfoOut.length==0){
          config.sortInfoOut =undefined;
        }else{
          config.sortInfoOut=this.sortInfoOut;
        }
      }
      config.sampleStart = this.parameters.sampleStart - 1;
      config.sampleEnd = this.parameters.sampleEnd - 1;
      config.runAll = this.parameters.runAll;
      config.timestampField = this.timestampField;
      config.groupBy = this.groupBy;
      config.groupByL2 = this.groupByL2;
      config.defSourceField = this.defSourceField;
      config.entityList = this.entityList;
      config.userField = this.userField;
      config.sequenceL2= this.sequenceL2,
      config.bufferRows= this.bufferRows,
      config.threads= this.threads,
      config.listSeparator = this.listSeparator;
      config.defTimeout= this.defTimeout,
      config.orderField = this.orderField;
      config.isOpenField = this.isOpenField;
      config.isCloseField = this.isCloseField;
      config.entityStart = this.entityStart;
      config.entityEnd = this.entityEnd;
      config.subRows = this.subRows;
      config.addFields = this.addFields;
      config.resetRows = this.resetRows;
      config.noRules = true;

      config.mapTable = this.mapTable.filter(m=>m.mapFrom && m.mapTo).map(r => {
        const rule = r.toRule();
        return rule;
      });

      return config;
    }

    public override onTransformRunCompleted(response: FarmConverterTransformPreviewDataResponse): void {
      // Clear
      this.inputRows = null;
      this.outputRows = null;
      this.aggRatio = null;
      this.aggRatioDisplay ="0.00%";
      this.rows = 0;

      // if (
      //   !response?.previewStats ||
      //   !response?.totalStats ||
      //   !response.totalStats.globalStat ||
      //   !response.totalStats.ruleStats ||
      //   !response.previewStats.globalStat ||
      //   !response.previewStats.ruleStats
      // ) {
      //   return;
      // }

      if (this.parameters.runAll) {
        // Map Transform Global and Rule stats
        this.inputRows = response.totalStats?.globalStat.rowHits;
        this.outputRows = response.totalStats?.globalStat.groupHits;
        this.aggRatio = response.totalStats.globalStat.hitRate;
        this.aggRatioDisplay = `${(this.aggRatio * 100).toFixed(2)}%`;
      } else {
        // Map Transform Global and Rule stats
        this.inputRows = response.previewStats.globalStat.rowHits;
        this.outputRows = response.previewStats.globalStat.groupHits;
        this.aggRatio = response.previewStats.globalStat.hitRate;
        this.aggRatioDisplay = `${(this.aggRatio * 100).toFixed(2)}%`;
      }
      
      this.rows = this.parameters.runAll ? response.currentData?.totalRows : response.activeData?.totalRows;

      // map the rule stats to the rule
      // if (response.previewStats.ruleStats) {
      //   for (let i = 0; i < this.mapTable.length; i++) {
      //     const ruleStat = response.previewStats.ruleStats.find(r => r.ruleIndex === i);
      //   }
      // }

      // map the rule stats to the rule
      // if (response.totalStats.ruleStats) {
      //   for (let i = 0; i < this.mapTable.length; i++) {
      //     const ruleStat = response.totalStats.ruleStats.find(r => r.ruleIndex === i);
         
      //   }
      // }
    }

}
